import React, { useState, useEffect } from "react";

const SkillResources = (props) => {
  const { skillStoreForm, updateSkillStoreForm, resourceErrors } = props;

  const skillResources = skillStoreForm?.SkillResources ?? [];
  const safeResourceErrors = Array.isArray(resourceErrors)
    ? resourceErrors
    : [];

  const [skillResourceErrors, setSkillResourceErrors] = useState([]);

  useEffect(() => {
    setSkillResourceErrors(safeResourceErrors);
  }, [safeResourceErrors]);

  const handleResourceChange = (index, field, newValue) => {
    // Update resources
    const updatedResources = [...skillResources];

    if (index >= 0 && index < updatedResources.length) {
      updatedResources[index] = {
        ...updatedResources[index],
        [field]: newValue,
      };

      updateSkillStoreForm("SkillResources", updatedResources);
    }

    // Clear error for this field
    const updatedErrors = [...(skillResourceErrors || [])];

    if (index >= 0 && index < updatedErrors.length) {
      updatedErrors[index] = {
        ...updatedErrors[index],
        [field]: "",
      };
      setSkillResourceErrors(updatedErrors);
    }
  };

  const addResource = () => {
    updateSkillStoreForm("SkillResources", [
      ...skillResources,
      { Id: 0, ResourceId: "", ResourceName: "" },
    ]);

    // Keep errors array in sync
    setSkillResourceErrors((prev) => [
      ...(prev || []),
      { ResourceId: "", ResourceName: "" },
    ]);
  };

  const removeResource = (index) => {
    updateSkillStoreForm(
      "SkillResources",
      skillResources.filter((_, i) => i !== index)
    );

    setSkillResourceErrors((prev) =>
      (prev || []).filter((_, i) => i !== index)
    );
  };

  return (
    <>
      <div className="resource-add">
        <h2 className="h2">Resource</h2>
        {skillResources.length === 0 && (
          <div onClick={addResource} className="plus-icon-white-bot"></div>
        )}
      </div>

      <div className="form-group"></div>

      {skillResources.length > 0 && (
        <div className="all-variavle-inputs">
          {skillResources.map((item, index) => (
            <div key={index} className="variable-input">
              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="Resource Id"
                  value={item.ResourceId}
                  maxLength={450}
                  onChange={(e) =>
                    handleResourceChange(index, "ResourceId", e.target.value)
                  }
                  className={
                    skillResourceErrors?.[index]?.ResourceId
                      ? "error-border"
                      : ""
                  }
                />
                {skillResourceErrors?.[index]?.ResourceId && (
                  <span className="error-text">
                    {skillResourceErrors[index].ResourceId}
                  </span>
                )}
              </div>

              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="Resource Name"
                  value={item.ResourceName}
                  maxLength={450}
                  onChange={(e) =>
                    handleResourceChange(index, "ResourceName", e.target.value)
                  }
                  className={
                    skillResourceErrors?.[index]?.ResourceName
                      ? "error-border"
                      : ""
                  }
                />
                {skillResourceErrors?.[index]?.ResourceName && (
                  <span className="error-text">
                    {skillResourceErrors[index].ResourceName}
                  </span>
                )}
              </div>

              <div className="button-wrap-row">
                <button onClick={() => removeResource(index)}>
                  <div className="minus-icon-white"></div>
                </button>

                {index === skillResources.length - 1 && (
                  <button onClick={addResource}>
                    <div className="plus-icon-white-bot"></div>
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default SkillResources;
